import { jsx as _jsx } from "react/jsx-runtime";
import { FrozeContext } from "./hooks";
function Frozen(param) {
  var { on = false, children } = param;
  return /* @__PURE__ */ _jsx(FrozeContext.Provider, {
    value: on,
    children
  });
}
export {
  Frozen
};
//# sourceMappingURL=Frozen.native.js.map
